import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { EditSquare, IsOpen } from '../../../components/Icon';
import { UIToggle } from '../../../containers/App/actions';
import { selectUIToggle } from '../../../containers/App/selectors';
import { BPMPriceListModal } from './BPMPriceListModal';
import cn from 'classnames';
import styles from './CardBPM.module.css';
import {
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_BPM_CARD_TYPES,
} from '../constants';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Loader } from '../../../components/Loader';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { setVehicleProperties } from '../actions';
import { Cell, List, Row } from '../../../components/List';
import { formatCurrencyValue } from '../../../utils/string';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';


const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .info-cell {
    white-space: nowrap;
  }

  .info-cell:hover {
    cursor: pointer;
  }

  .button-block {
    width: 50%;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  input {
    width: 100%;
  }
`;

const STATE = {
  active: false,
  isEditVehicle: false,
  isOpen: false,  
};  
  


/* eslint-disable react/prefer-stateless-function */
class VehicleBpmCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  componentDidMount() {
    if (hasPermissions(this.props.permissions, DEP_FINANCE || DEP_COMMERCE || DEP_ADMINISTRATION )) {
      this.setState({ isOpen: true });
    }
    VEHICLE_BPM_CARD_TYPES.map(property => {
      if (this.props.vehicle[property]) {
        this.setState({ [property]: this.props.vehicle[property] });
      }
    });
  }

  handleEdit() {
    this.setState({ isEditVehicle: true });
  }

  input(type) {
    return (
      <FormField>
        <Input value={this.state[type]} onChange={evt => this.setState({ [type]: evt.target.value })} />
      </FormField>
    );
  }

  isShowEditButton() {
    return !this.state.isEditVehicle && (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE) && this.state.isOpen;
  }

  isShowPropertyCell(type) {
    if (this.state.isEditVehicle && this.props.vehicle[type]) {
      return true;
    }
    if (this.props.vehicle[type] && this.props.vehicle[type] !== 'null' && !this.state.isEditVehicle) {
      return true;
    }
    return false;
  }

  edit() {
    let properties = [];
    VEHICLE_BPM_CARD_TYPES.map(type => {
      if (this.state[type]) {
        properties.push({
          propertyName: type,
          propertyValue: this.state[type],
        });
      }
    });

    this.props.patch(properties, callback => {
      this.reset();
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  resetProps() {
    VEHICLE_BPM_CARD_TYPES.map(property => {
      if (this.props.vehicle[property]) {
        this.setState({ [property]: this.props.vehicle[property], isOpen: false, isEditVehicle: false });
      }
    });
  }

  render() {
    if (!this.props.vehicle) return null;
    const vehicle = this.props.vehicle;

    return (
      <Card className={cn('vehicle-info-card info-card bpm', styles.card)}>
        {this.props.work ? (
          <Loader small />
        ) : (
          <Container>
            <HBox>
              <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.bpm.title')}</h2>
              <HBox right style={{ width: '50%' }}>
                {this.state.isEditVehicle && (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE) && (
                  <HBox className="button-block" right>
                    <Button small select onClick={this.resetProps.bind(this)}>
                      {this.lbl('cancel')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button small onClick={this.edit.bind(this)}>
                      {this.lbl('save')}
                    </Button>
                  </HBox>
                )}
                {this.isShowEditButton() && (
                  <div
                    className="icon-block"
                    onClick={() => {
                      this.setState({ isEditVehicle: true });
                    }}
                  >
                    <EditSquare />
                  </div>
                )}

                <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                  <IsOpen />
                </div>
              </HBox>
            </HBox>

            {this.state.isOpen && (
              <>
      
                {env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE  && (
                  <List>
                    {VEHICLE_BPM_CARD_TYPES.map(property => {
                      return (
                        this.isShowPropertyCell(property) && (
                          <Row className="row-property" key={property}>
                            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                            {this.state.isEditVehicle ? (
                              <Cell>{this.input(property)}</Cell>
                            ) : (
                              <Cell className="info-cell">
                                {['indication_rest_bpm', 'indication_gross_bpm'].includes(property)
                                  ? formatCurrencyValue(vehicle[property])
                                  : `${vehicle[property]} g/km`}
                              </Cell>
                            )}
                          </Row>
                        )
                      );
                    })}
                  </List>
                )}
                <Button className={styles.button} small onClick={this.props.activate}>
                  {this.lbl('vehicle.info.bpm.pricelist.cta')}
                </Button>
              </>
            )}
          </Container>
        )}
        {this.renderModal()}
      </Card>
    );
  }

  renderModal() {
    if (!this.props.active || !this.props.vehicle) return null;
    return <BPMPriceListModal onCancel={this.props.deactivate} vehicle={this.props.vehicle} />;
  }
}

VehicleBpmCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    active: selectUIToggle('CardBpmModalActive'),
    work: selectWorks([
      REQUEST_VEHICLE,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`,
    ]),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    activate() {
      dispatch(UIToggle('CardBpmModalActive', true));
    },
    deactivate() {
      dispatch(UIToggle('CardBpmModalActive', false));
    },
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle?.id, props, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleBpmCard = compose(withConnect, withRouter)(VehicleBpmCardComp);
